export type NoticeCanvasSize = { width: number; height: number };
export const NOTICE_CANVAS_PREFERENCE_KEY = 'bricklit-notice-canvas-preference-v1';
export const validNoticeCanvasSize = (size: NoticeCanvasSize): boolean =>
  Number.isSafeInteger(size.width) && size.width > 0 && Number.isSafeInteger(size.height) && size.height > 0;
export function readNoticeCanvasPreference(fallback: NoticeCanvasSize): NoticeCanvasSize {
  try {
    const value = JSON.parse(localStorage.getItem(NOTICE_CANVAS_PREFERENCE_KEY) ?? 'null') as NoticeCanvasSize | null;
    return value && validNoticeCanvasSize(value) ? { width: value.width, height: value.height } : fallback;
  } catch { return fallback; }
}
export function saveNoticeCanvasPreference(size: NoticeCanvasSize): void {
  if (!validNoticeCanvasSize(size)) return;
  try { localStorage.setItem(NOTICE_CANVAS_PREFERENCE_KEY, JSON.stringify(size)); } catch { /* Editing still works when storage is unavailable. */ }
}
